import api from '@/services/api'
import Brand from '@/models/brand'
import { BRAND_CODE, BRANDS } from '@/utils/brand-detector'

export default {
  namespaced: true,
  state: {
    brands: {},
    settings: {},
    BRAND_CODE
  },
  getters: {
    BRAND: state => {
      if (state.BRAND_CODE) {
        return new Brand(BRANDS[state.BRAND_CODE], state.brands[state.BRAND_CODE])
      }
      return null
    }
  },
  mutations: {
    setInit (state, data) {
      state.brands = data.brands
      state.settings = data.settings
    }
  },
  actions: {
    async loadInit ({ commit }) {
      const data = await api.app.loadInit()
      commit('setInit', data)
    }
  }
}
